import debug from "debug";
import plugin from '../../lib/plugin';

const MODULE_NAME = 'app.core/modules/disable-on-submit';
const log = debug(MODULE_NAME);

const ELEMENT_SELECTOR = '[data-disable-on-submit]';
const PROGRESS_CLASS = 'has-progress';


class DisableOnSubmit {
    constructor(element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$submitButton = $('[type="submit"]', element);
        log('DisableOnSubmit', element, options);
        this.watch();
    }

    onSubmit(event) {
        const form = this.$element;
        this.$submitButton
            .attr('disabled','disabled')
            .addClass(PROGRESS_CLASS);

    }

    watch() {
        this.$element.on('submit.disableonsubmit', this.onSubmit.bind(this));
        log('bound', this.element);
    }

    unwatch() {
        this.$element.off('.disableonsubmit');
        this.$submitButton
            .removeAttr('disabled')
            .removeClass(PROGRESS_CLASS);
        log('unbound', this.element);
    }
}

DisableOnSubmit.DEFAULTS = {};

plugin('disableOnSubmit', DisableOnSubmit);

export function exec() {
    $(document).ready(() => {
        log('binding');
        $(ELEMENT_SELECTOR).disableOnSubmit();
        log('bound');
    });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/disable-on-submit/index.js